import React from 'react'

const PencilIcon = (
  <path
    d="M0.494141 12.9222V16.4168H3.98872L13.3076 7.09793L9.81301 3.60334L0.494141 12.9222ZM3.98872 15.252H1.659V12.9222H2.82386V14.0871H3.98872V15.252ZM15.9868 4.41874L14.4724 5.93306L10.9779 2.43848L12.4922 0.924153C12.5999 0.816166 12.728 0.730494 12.8689 0.672039C13.0098 0.613585 13.1608 0.583496 13.3134 0.583496C13.466 0.583496 13.617 0.613585 13.7579 0.672039C13.8989 0.730494 14.0269 0.816166 14.1346 0.924153L15.9868 2.77629C16.441 3.23058 16.441 3.96445 15.9868 4.41874Z"
    fill="#222222"
  />
)

export default PencilIcon
